module.exports = __webpack_public_path__ + "static/open-banking-de0a4bf140ca88afdae4a4353364192c.svg";